"use client";
import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { list } from './styles.js';
import { useTheme } from '../utils/theming/useTheme.js';
import { ThemeProvider } from 'styled-components';

var _excluded = ["size", "indent", "alignDescription", "divided"];
var DescriptionList = function DescriptionList(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === undefined ? 'basic' : _ref$size,
    _ref$indent = _ref.indent,
    indent = _ref$indent === undefined ? false : _ref$indent,
    _ref$alignDescription = _ref.alignDescription,
    alignDescription = _ref$alignDescription === undefined ? 'left' : _ref$alignDescription,
    dividedProp = _ref.divided,
    props = _objectWithoutProperties(_ref, _excluded);
  var theme = useTheme();
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React.createElement(list, _extends({
    "data-testid": "elemental-DescriptionList",
    $size: size,
    $indent: indent,
    $alignDescription: alignDescription,
    $divided: dividedProp
  }, props)));
};

export { DescriptionList };
